export default "__VITE_ASSET__Dk06Ydvl__"